var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1952 12.5857C13.6015 9.18179 16.3798 6.36931 16.3693 6.3358C16.3326 6.21972 15.7337 5.94113 15.267 5.82314C14.815 5.70879 14.614 5.70508 9.72905 5.72046L4.66014 5.73644L4.66014 4.89103L4.66014 4.04562L9.34377 4.00117C14.1446 3.95557 14.8387 3.97568 15.6893 4.18468C17.6109 4.6569 19.2387 6.22798 19.7771 8.12983C20.0021 8.92456 20.0206 9.47318 19.9911 14.4574L19.9625 19.289L19.1176 19.289L18.2726 19.2891L18.2917 14.4873C18.3133 9.07133 18.3002 8.81464 17.9648 8.11152C17.8501 7.87105 17.715 7.65851 17.6645 7.63913C17.6 7.61441 15.7308 9.44542 11.3859 13.7896L5.19907 19.9753L4.60054 19.379C4.27133 19.051 4.00195 18.7809 4.00195 18.7787C4.00195 18.7765 6.78894 15.9897 10.1952 12.5857Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRight);
export default __webpack_public_path__ + "static/media/arrow-top-right.7dbe75127e809ae138b911f9f6d71373.svg";
export { ForwardRef as ReactComponent };